import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { getErrorMessage } from '../../utils/errorHandler';
import cuotasAPI, { Cuota, CuotaData } from './ctaCorrienteAPI';

export interface ParsedCuota extends Cuota {
  id: string;
}

interface CuotasState {
  status: 'loading' | 'idle' | 'error' | 'success';
  error?: string;
  list?: ParsedCuota[];
}

export const initialState: CuotasState = {
  status: 'idle',
  list: [],
};

export const getCuotasByResource = createAsyncThunk<
  ParsedCuota[],
  CuotaData,
  { rejectValue: string }
>('imponibles/cuotas', async (data, thunkAPI) => {
  try {
    const response = await cuotasAPI.getCuotasByResource(data);

    if (response.status === 'error') {
      return thunkAPI.rejectWithValue(response.error);
    }

    // Agrego identificador a las cuotas
    const parsedCuotas: ParsedCuota[] = response.data
      .filter(item => parseFloat(item.monto_original) > 0)
      .map(item => ({
        ...item,
        id: `${item.cuota}/${item.anio}`,
      }));

    return parsedCuotas;
  } catch (err) {
    return thunkAPI.rejectWithValue(getErrorMessage(err));
  }
});

export const CuotasState = createSlice({
  name: 'CuotasState',
  initialState,
  reducers: {
    cleanCuotasState() {
      return {
        ...initialState,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCuotasByResource.pending, state => {
        state.status = 'loading';
        state.list = undefined;
      })
      .addCase(getCuotasByResource.fulfilled, (state, action) => {
        state.status = 'success';
        state.list = action.payload;
      })
      .addCase(getCuotasByResource.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload;
      });
  },
});

export const getCuotasList = (state: RootState) => state.cuotas.list ?? [];
export const getCuotasStatus = (state: RootState) => state.cuotas.status;
export const { cleanCuotasState } = CuotasState.actions;

export default CuotasState.reducer;
